/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, { task: payload });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, { task: payload });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  markStatus(id, status) {
    return axios.patch(`${this.url}/${id}`, { task: { status } });
  }
}

export default new TasksAPI();
